import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Emoji = ({ label, symbol, inline = false }) => (
  <span
    className={classNames('text-[1.1em]', {
      inline,
    })}
    role="img"
    aria-label={label || ''}
    aria-hidden={label ? 'false' : 'true'}
  >
    {symbol}
  </span>
);

Emoji.propTypes = {
  inline: PropTypes.bool,
  label: PropTypes.string,
  symbol: PropTypes.string,
};

export default Emoji;
